import mutations from './mutations.js';
import getters from './getters.js';
import actions from './actions.js';

const ProchipModule = {
  namespaced: true,
  state() {
    return {
      years: [],
      cplds: [],
      cpldVolumes: [],
      hdls: [],
      prochipData: {},
      isProchipAPIError:false,
      accessToken: null,
      userProfileDetails: {}
    };
  },
  mutations,
  getters,
  actions
};

export default ProchipModule;